import { useI18n } from 'vue-i18n'
import columnStore from '@/stores/column'

export default function useSubAssetColumns(component: string) {
	const i18n = useI18n()
	const cols = columnStore()

	const inventoryNr = cols.define(component, 'inventory_nr', i18n.t('asset.inventoryNr'), false)
	const name = cols.define(component, 'name', i18n.t('misc.name'), true)
	const location = cols.define(component, 'location', i18n.t('location'), true)
	const price = cols.define(component, 'price', i18n.t('price'), false)
	const responsible = cols.define(component, 'responsible', i18n.t('responsible'), true)
	const status = cols.define(component, 'status', i18n.t('asset.status.label'), true)
	const comment = cols.define(component, 'comment', i18n.t('misc.comment'), true)

	const columns = { inventoryNr, name, location, price, responsible, status, comment }

	const { custom, all } = cols.finalize(component, columns, true, ['sub_assets'])

	return { columns, custom, all }
}
